import { type ReactNode } from "react";
import { useMatch } from "react-router-dom";

import { TemplatesWithLifecyclePicker } from "./TemplatesWithLifecyclePicker";

type Props = { children: ReactNode };

export function LifecycleFilterGuard({ children }: Props) {
    const listMatch = useMatch("/create/templates");
    if (listMatch) {
        return <TemplatesWithLifecyclePicker />;
    }
    return <>{children}</>;
}
